import { API_URL } from '../../../../utils/config';

export const GET_CATEGORIES_URL = `${API_URL}/adminRequest/category`;
export const CREATE_REQUEST_URL = `${API_URL}/adminRequest`;
export const GET_EMPLOYEE_REQUESTS_URL = `${API_URL}/adminRequest/employee`;
